import { render, staticRenderFns } from "./SpaceTeamsForm.vue?vue&type=template&id=db70c9f6&scoped=true&"
import script from "./SpaceTeamsForm.vue?vue&type=script&lang=js&"
export * from "./SpaceTeamsForm.vue?vue&type=script&lang=js&"
import style0 from "./SpaceTeamsForm.vue?vue&type=style&index=0&id=db70c9f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db70c9f6",
  null
  
)

export default component.exports